import React from "react";
import Lottie from "lottie-react";
import uxDocAnimation from "../../assets/lottieJsons/UXDOC-loading-speed.json";

import { useLottie } from "lottie-react";

const ContractAnimation: React.FC = () => {
  const options = {
    animationData: uxDocAnimation,
    loop: true
  };

  const { View } = useLottie(options);

  return <div className="responsive-loading">{View}</div>;
};

export { ContractAnimation };
